var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/AWS@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/AWS"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F4FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.976074, 7.999023)",
    id: "amazon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80067365,5.25133978 C9.80067365,3.67232241 10.0043875,2.47098214 8.4099292,2.47500025 C8.4099292,2.47500025 6.92516346,2.47500025 6.28659645,4.46383953 L3.40716903,4.19062451 C3.40716903,2.20982143 5.23668265,0 8.68416038,0 C12.1238031,0 13.0836122,2.29017857 13.0836122,3.30669594 L13.0836122,9.21696404 C13.0836122,10.3218748 14.3489927,11.3383933 14.3489927,11.3383933 L12.1238031,13.5883933 C11.735962,13.2147331 10.6037793,12.1178586 10.349136,11.7080367 C8.57838621,14.5526791 3.16036144,14.3718755 3.16036144,9.97232192 C3.16036144,5.87410763 7.89280826,5.32366071 9.80067365,5.25133978 Z M9.80067365,7.10758965 C8.48044651,7.15178633 6.5020644,7.53348276 6.5020644,9.4299112 C6.5020644,11.4709821 9.80067365,11.953125 9.80067365,8.73883929 L9.80067365,7.10758965 Z",
    id: "Shape",
    fill: "#232F3E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.320109305,13.6084826 C3.19170167,15.3964291 7.6773403,18.3415179 14.9131264,14.8258929 C15.2069455,14.6772317 15.4341652,14.90625 15.1285938,15.3080357 C14.826939,15.7098214 12.3862819,18 8.29240215,18 C4.19852235,18 1.06445109,15.1272321 0.104641947,13.9419643 C-0.161754179,13.6325888 0.14381783,13.4879469 0.320109305,13.6084826 Z M16.9424367,13.6647336 C17.0873879,13.8696446 16.9424367,14.7535731 16.6877935,15.3964303 C16.4331502,16.03125 16.0609793,16.4732143 15.8572642,16.6419648 C15.6417969,16.8227683 15.4850934,16.7504474 15.602621,16.4892867 C15.7201487,16.228126 16.3587151,14.6209831 16.1001552,14.2794653 C15.845512,13.9459836 14.6506475,14.1066979 14.2197128,14.1508933 L14.1026005,14.1628143 L13.9220625,14.1834742 C13.7491323,14.2032461 13.6986736,14.2035274 13.6712504,14.1388403 C13.5811464,13.9098219 14.5213676,13.5160724 15.1403461,13.4357153 C15.7554079,13.3633943 16.7465573,13.4035729 16.9424367,13.6647336 Z",
    id: "Path-2",
    fill: "#FF9900",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeAws);
export default __webpack_public_path__ + "static/media/type-aws.b70bfe2f974d1d224535f89051358b3c.svg";
export { ForwardRef as ReactComponent };